const dateRangePicker = document.querySelectorAll('.date-range-picker');

dateRangePicker.forEach((rangePicker) => {
  const initElem = rangePicker.querySelector('.date-range-picker__range');
  const startDate = rangePicker.querySelector('.start-date input');
  const endDate = rangePicker.querySelector('.end-date input');

  mobiscroll.datepicker(initElem, {
    controls: ['calendar'],
    select: 'range',
    theme: 'ios',
    themeVariant: 'light',
    startInput: startDate,
    endInput: endDate,
    pages: 1,
    min: new Date(),
    locale: localData?.calendar?.locale || mobiscroll.localeEs,
    responsive: {
      custom: {
        breakpoint: 767,
        pages: 2,
      },
    },
  });
});
